module.exports = __webpack_public_path__ + "img/add_template.0f8e199a.svg";